import { useDocumentChatContext } from '@/modules/chat/contexts/DocumentChatProvider';
import {
  ChatErrorState,
  ChatLoadingState,
} from '@/modules/common/Chat/components/ChatStatusRow';
import { ChatTranscript } from '@/modules/common/Chat/components/ChatTranscript';

import { DocumentChatMessage } from './DocumentChatMessage';

export interface DocumentChatTranscriptProps {
  enableCopyCitationPopover?: boolean;
}

export function DocumentChatTranscript({
  enableCopyCitationPopover = false,
}: DocumentChatTranscriptProps) {
  const {
    messages,
    awaitingFirstToken,
    error,
    streamingMessageId,
    pendingScrollToMessageId,
    clearPendingScroll,
  } = useDocumentChatContext();

  return (
    <ChatTranscript
      messages={messages}
      scrollToMessageId={pendingScrollToMessageId}
      onScrollTargetReached={clearPendingScroll}
      loadingState={awaitingFirstToken ? <ChatLoadingState /> : undefined}
      errorState={error ? <ChatErrorState error={error} /> : undefined}
      renderMessage={({ message }) => (
        <DocumentChatMessage
          message={message}
          enableCopyCitationPopover={enableCopyCitationPopover}
          isStreaming={message.id === streamingMessageId}
        />
      )}
    />
  );
}
